import { HStack, Button, Tooltip, Text, useStyleConfig, Link, Heading } from '@chakra-ui/react';
import { onLink, onSave } from '../../handlers';

import {
  RiAccountBoxLine,
  RiEyeLine,
  RiFileDownloadLine,
  RiLogoutBoxRLine,
  RiSave3Fill,
} from 'react-icons/ri';
import { openPreview } from '../Preview/utils';
import { getUsefulVars } from '../../handlers/helpers';

const NavActionsIcons = ({ props }) => {
  const uv = getUsefulVars(props);
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const headerStyles = useStyleConfig('Header', { variant });
  const sectionName = uv.stateProps.sectionData.sectionName;
  const hidePreviewButtons = (sectionName === 'resumes' || sectionName === 'professional-experience' || sectionName === 'preview') ? true : false;
  const hostname = window.location.hostname;
  const appType = window.appType;
  return (
    <HStack spacing={0}>
      {(appType !== 'cm' && appType !=='int' && appType !== 'mi' && appType !== 'city') &&
      <Tooltip label="Save" hasArrow sx={{ ...headerStyles.tooltip }}>
        <Button
          sx={{  ...buttonStyles.tertiary, ...buttonStyles.icon  }}
          onClick={e => onSave(e, uv.formikProps, uv.stateProps, uv.resumeIndex)}
        >
          <Text sx={{ ...headerStyles.navActionsButtonText }}>
            <RiSave3Fill />
          </Text>
        </Button>
      </Tooltip>
    }
      {(appType === 'cm'  && hostname === 'appdemo.resumescripter.com' ) &&
        <Button as="a"
                width='fit-content'
                paddingRight='.5rem'
                paddingLeft='.5rem'
                marginRight='1rem'
                sx={{ ...buttonStyles.primary }}
                href="https://resumescripter.com/signup?hsLang=en"
        >
          Sign Up
        </Button>
      }
{(appType === 'cm'  && hostname === 'appdemo.resumescripter.com' ) &&
        <Button as="a"
                width='fit-content'
                paddingRight='.5rem'
                paddingLeft='.5rem'
          sx={{ ...buttonStyles.primary }}
                href="https://resumescripter.com/login?hsLang=en"
        >
            Login
        </Button>
}
      {window.location.hostname === 'app.resumescripter.com' &&
        <Tooltip label="Logout" hasArrow sx={{ ...headerStyles.tooltip }}>

          <Button
            sx={{ ...buttonStyles.tertiary, ...buttonStyles.icon }}
            onClick={() => window.open('/logout', '_blank')}
          >
            <Text sx={{ ...headerStyles.navActionsButtonText, ...buttonStyles.logout }}>
              <RiLogoutBoxRLine />
            </Text>
          </Button>
        </Tooltip>
      }
      {window.location.hostname === 'app.resumescripter.com' &&
        <Tooltip label="Account" hasArrow sx={{ ...headerStyles.tooltip }}>
          <Button
            sx={{ ...buttonStyles.tertiary, ...buttonStyles.icon }}>
            <Link sx={{ ...headerStyles.navActionsButtonText }} isExternal
                  href="https://app.resumescripter.com/customer-dashboard"
            >
              <RiAccountBoxLine />
            </Link></Button>
        </Tooltip>
      }
    </HStack>
  );
};

export default NavActionsIcons;
/**
 *
 *

 {!hidePreviewButtons &&
 <>

 <Tooltip label="Download"  hasArrow sx={{...headerStyles.tooltip}} >
 <Button
 sx={{...buttonStyles.tertiary,...buttonStyles.icon}}
 onClick={() => openPreview(props)}
 >
 <Text sx={{...headerStyles.navActionsButtonText}}>
 <RiFileDownloadLine />
 </Text>
 </Button>
 </Tooltip>
 </>
 }
 {isMenu &&
 <Tooltip
 label="parse"
 hasArrow
 bg="ORANGE"
 color="BLACK"
 fontWeight={600}
 borderRadius={99}
 >
 <Button
 variant="icon"
 border="none"
 margin="0"
 onClick={e => resetParse(stateProps, formikProps)}
 >
 <Text color="ORANGE" fontSize={32}>
 ..
 </Text>
 </Button>
 </Tooltip>
 }
 {
 <Tooltip
 label="download"
 hasArrow
 bg="ORANGE"
 color="BLACK"
 fontWeight={600}
 borderRadius={99}
 >
 <Button
 variant="icon"
 border="none"
 margin="0"
 onClick={e => onLink(false, formikProps, stateProps, 'survey', 0, '')}
 >
 <Text color="ORANGE" fontSize={20}>
 <FaDownload />
 </Text>
 </Button>
 </Tooltip>


 <Tooltip label="Preview"  hasArrow sx={{...headerStyles.tooltip}} >
 <Button
 sx={{...buttonStyles.tertiary,...buttonStyles.icon}}
 onClick={() => openPreview(props)}
 >
 <Text sx={{...headerStyles.navActionsButtonText}}>
 <RiEyeLine />
 </Text>
 </Button>
 </Tooltip>
 }*/